var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 296,
    viewBox: "0 0 348 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 415C345.66 415 412 347.92 412 265.5C412 183.08 345.66 116 263.5 116C181.34 116 115 183.08 115 265.5C115 347.92 181.34 415 263.5 415Z",
    stroke: "#516CD3",
    strokeWidth: 40
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.5 511C398.149 511 507 400.918 507 265.5C507 130.082 398.149 20 263.5 20C128.851 20 20 130.082 20 265.5C20 400.918 128.851 511 263.5 511Z",
    stroke: "#516CD3",
    strokeWidth: 40
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing2);
export default __webpack_public_path__ + "static/media/Ring2.f31e21e053b5faccfb4b3e709c2d2299.svg";
export { ForwardRef as ReactComponent };